import { Controller } from "@hotwired/stimulus";

// Accordéon de la FAQ publique.
//
// Les classes ouvertes/fermées viennent de la vue (valeurs Stimulus) : le
// design reste dans le gabarit, le contrôleur ne gère que l'état.
export default class extends Controller {
  static targets = ["trigger", "content", "icon", "question", "iconWrap"];
  static values = {
    openCard: String,
    closedCard: String,
    openQuestion: String,
    closedQuestion: String,
    openIconWrap: String,
    closedIconWrap: String,
    openIcon: String,
    closedIcon: String,
  };

  toggle(event) {
    const index = event.currentTarget.dataset.faqsIndex;
    const isOpen = event.currentTarget.getAttribute("aria-expanded") === "true";

    this.closeAll();
    if (!isOpen) this.openAt(index);
  }

  closeAll() {
    this.triggerTargets.forEach((trigger, idx) => {
      trigger.setAttribute("aria-expanded", false);
      this.swap(trigger, this.openCardValue, this.closedCardValue);
      this.swap(this.questionTargets[idx], this.openQuestionValue, this.closedQuestionValue);
      this.swap(this.iconWrapTargets[idx], this.openIconWrapValue, this.closedIconWrapValue);

      // Fermé, la croix pivotée de 45° se lit comme un « + ».
      const icon = this.iconTargets[idx];
      this.swap(icon, this.openIconValue, this.closedIconValue);
      icon.classList.add("rotate-45");

      const content = this.contentTargets[idx];
      content.classList.add("max-h-0");
      content.style.maxHeight = "";
    });
  }

  openAt(index) {
    const idx = Number(index);
    const trigger = this.triggerTargets[idx];

    trigger.setAttribute("aria-expanded", true);
    this.swap(trigger, this.closedCardValue, this.openCardValue);
    this.swap(this.questionTargets[idx], this.closedQuestionValue, this.openQuestionValue);
    this.swap(this.iconWrapTargets[idx], this.closedIconWrapValue, this.openIconWrapValue);

    const icon = this.iconTargets[idx];
    this.swap(icon, this.closedIconValue, this.openIconValue);
    icon.classList.remove("rotate-45");

    // Hauteur réelle du contenu (réponse + bloc de retour d'expérience).
    const content = this.contentTargets[idx];
    content.classList.remove("max-h-0");
    content.style.maxHeight = `${content.scrollHeight}px`;
  }

  swap(element, remove, add) {
    if (!element) return;
    if (remove) element.classList.remove(...remove.split(" "));
    if (add) element.classList.add(...add.split(" "));
  }
}
